module.exports = __webpack_public_path__ + "static/flags/CY-922e18403051c373919a691fbf39d804.gif";